import React from 'react';
export interface IconProps {
  className?: string;
}
interface BaseProps extends IconProps {
  children: React.ReactNode;
  strokeWidth?: number;
}
function Svg({
  className = 'w-6 h-6',
  strokeWidth = 1.6,
  children
}: BaseProps) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" focusable="false" data-id="element-376" data-mp="3gi3zpqgc9kos">
      {children}
    </svg>;
}
export function ShieldIcon(props: IconProps) {
  return <Svg {...props} data-id="element-377" data-mp="2jto7fmlugx7z">
      <path d="M12 2.8 4.6 5.5v5.9c0 4.3 3 7.8 7.4 9.8 4.4-2 7.4-5.5 7.4-9.8V5.5L12 2.8Z" data-id="element-378" data-mp="2juh9495y4wj9" />
      <path d="m8.7 11.9 2.3 2.3 4.3-4.5" data-id="element-379" data-mp="2xtz08v6pslvs" />
    </Svg>;
}
export function YearsIcon(props: IconProps) {
  return <Svg {...props} data-id="element-380" data-mp="2srzw3j35hkxs">
      <circle cx="12" cy="12" r="9.2" data-id="element-381" data-mp="2svnrkns5ohf5" />
      <path d="M12 6.6V12l3.5 2.1" data-id="element-382" data-mp="d1dpt0hmynht" />
    </Svg>;
}
export function PriceTagIcon(props: IconProps) {
  return <Svg {...props} data-id="element-383" data-mp="8226bjpvx3wj">
      <path d="M3.8 12.4V4.6a.8.8 0 0 1 .8-.8h7.8c.2 0 .4.1.6.2l7 7a.8.8 0 0 1 0 1.2l-7.6 7.6a.8.8 0 0 1-1.2 0l-7-7a.9.9 0 0 1-.4-.4Z" data-id="element-384" data-mp="82k9l0aysidy" />
      <circle cx="8.4" cy="8.4" r="1.3" data-id="element-385" data-mp="15fo5qd4fqe6t" />
    </Svg>;
}
export function TrowelIcon(props: IconProps) {
  return <Svg {...props} data-id="element-386" data-mp="1aer8ts0uuac5">
      <path d="M14.8 3.2 20.8 9.2" data-id="element-387" data-mp="1aehj85jq256z" />
      <path d="M17.8 6.2 12.3 11.7" data-id="element-388" data-mp="1afk9qcd4u5md" />
      <path d="M12.3 11.7 3.4 14.3a.6.6 0 0 0-.3 1l5.6 5.6a.6.6 0 0 0 1-.3l2.6-8.9Z" data-id="element-389" data-mp="1fdu8ewy2focq" />
    </Svg>;
}
export function PhoneIcon(props: IconProps) {
  return <Svg {...props} data-id="element-390" data-mp="hrofrfey6rta">
      <path d="M6.2 3.5h3l1.5 3.8-2 1.4a12 12 0 0 0 6.6 6.6l1.4-2 3.8 1.5v3a1.7 1.7 0 0 1-1.9 1.7C11.4 18.9 5.1 12.6 4.5 5.4a1.7 1.7 0 0 1 1.7-1.9Z" data-id="element-391" data-mp="ho0luf5lc3e1" />
    </Svg>;
}
export function CameraIcon(props: IconProps) {
  return <Svg {...props} data-id="element-392" data-mp="wezrbhb4qbte">
      <path d="M3.4 8.6h3.1l1.6-2.4h7.8l1.6 2.4h3.1a.8.8 0 0 1 .8.8v9a.8.8 0 0 1-.8.8H3.4a.8.8 0 0 1-.8-.8v-9a.8.8 0 0 1 .8-.8Z" data-id="element-393" data-mp="wfhs8r8qle7n" />
      <circle cx="12" cy="13.6" r="3.4" data-id="element-394" data-mp="3v4gp89h7i46y" />
    </Svg>;
}
export function MessageIcon(props: IconProps) {
  return <Svg {...props} data-id="element-395" data-mp="3wubtp4oqncw">
      <path d="M20.8 12.2c0 4-3.9 7.2-8.8 7.2-1 0-2-.1-2.9-.4l-5 1.6 1.6-3.9a6.6 6.6 0 0 1-2.5-4.5C3.2 8.2 7.1 5 12 5s8.8 3.2 8.8 7.2Z" data-id="element-396" data-mp="3s3djgcogcylg" />
    </Svg>;
}
export function MailIcon(props: IconProps) {
  return <Svg {...props} data-id="element-397" data-mp="5nsro4uzoku3">
      <rect x="2.9" y="5.2" width="18.2" height="13.6" rx="1.8" data-id="element-398" data-mp="5oc3d3u1qczo" />
      <path d="m3.6 6.6 8.4 6 8.4-6" data-id="element-399" data-mp="5pn38skdf0li" />
    </Svg>;
}
export function WaveIcon(props: IconProps) {
  return <Svg {...props} data-id="element-400" data-mp="r25r0wi6v0r">
      <path d="M2.6 8.4c1.6-1.8 3.2-1.8 4.8 0s3.2 1.8 4.8 0 3.2-1.8 4.8 0 3.2 1.8 4.4.2" data-id="element-401" data-mp="393zkthfs2zom" />
      <path d="M2.6 13.2c1.6-1.8 3.2-1.8 4.8 0s3.2 1.8 4.8 0 3.2-1.8 4.8 0 3.2 1.8 4.4.2" data-id="element-402" data-mp="3537a0jr9cmq8" />
      <path d="M2.6 18c1.6-1.8 3.2-1.8 4.8 0s3.2 1.8 4.8 0 3.2-1.8 4.8 0 3.2 1.8 4.4.2" data-id="element-403" data-mp="3j2p5tj2z1093" />
    </Svg>;
}
export function TileIcon(props: IconProps) {
  return <Svg {...props} data-id="element-404" data-mp="3e2uan3c5xoi8">
      <rect x="3.2" y="3.2" width="7.4" height="7.4" rx="1.1" data-id="element-405" data-mp="3e5oxt2mk9nfc" />
      <rect x="13.4" y="3.2" width="7.4" height="7.4" rx="1.1" data-id="element-406" data-mp="ybeydlzik5l6" />
      <rect x="3.2" y="13.4" width="7.4" height="7.4" rx="1.1" data-id="element-407" data-mp="tdn4imfb69ec" />
      <rect x="13.4" y="13.4" width="7.4" height="7.4" rx="1.1" data-id="element-408" data-mp="td4wytn748r4" />
    </Svg>;
}
export function DeckIcon(props: IconProps) {
  return <Svg {...props} data-id="element-409" data-mp="2g9usqc688qus">
      <path d="M2.8 18.4 6.4 8.2h11.2l3.6 10.2" data-id="element-410" data-mp="2gacufobnrxa3" />
      <path d="M2.8 18.4h18.4" data-id="element-411" data-mp="2g807sxuygyqp" />
      <path d="M8.4 8.2 7 18.4M12 8.2v10.2M15.6 8.2 17 18.4" data-id="element-412" data-mp="22av1qxv8rzvg" />
      <path d="M4.9 13.3h14.2" data-id="element-413" data-mp="22celwzk0qv2i" />
    </Svg>;
}
export function CopingIcon(props: IconProps) {
  return <Svg {...props} data-id="element-414" data-mp="27biupp316qsb">
      <path d="M2.8 7.6h18.4" data-id="element-415" data-mp="2uz91bi1zb494" />
      <path d="M4.6 7.6v3.1c0 4.1 3.3 7.4 7.4 7.4s7.4-3.3 7.4-7.4V7.6" data-id="element-416" data-mp="2v021g06fmvia" />
      <path d="M8.2 12.6c1.3-1.1 2.6-1.1 3.8 0s2.5 1.1 3.8 0" data-id="element-417" data-mp="2z0ce1voqck64" />
    </Svg>;
}
export function RemodelIcon(props: IconProps) {
  return <Svg {...props} data-id="element-418" data-mp="2l84k0botz7b4">
      <path d="M3.2 10.6 12 3.6l8.8 7" data-id="element-419" data-mp="2l8xkww13z2lc" />
      <path d="M5.5 12.4v7.2c0 .5.4.8.9.8h11.2c.5 0 .9-.3.9-.8v-7.2" data-id="element-420" data-mp="2q80rikwqlgvf" />
      <path d="M9.2 16.4c1-.9 2-.9 3 0s2 .9 3 0" data-id="element-421" data-mp="2q663gxq658n4" />
    </Svg>;
}
export function CheckIcon(props: IconProps) {
  return <Svg {...props} strokeWidth={2} data-id="element-422" data-mp="3iol86b9u3089">
      <path d="m4.8 12.4 4.6 4.6 9.8-10.4" data-id="element-423" data-mp="3iotpcfczorp9" />
    </Svg>;
}
export function AlertIcon(props: IconProps) {
  return <Svg {...props} data-id="element-424" data-mp="1u3tqf7vq9gr1">
      <path d="M12 3.6 2.9 19.4a.8.8 0 0 0 .7 1.2h16.8a.8.8 0 0 0 .7-1.2L12 3.6Z" data-id="element-425" data-mp="1u421cu8aibzl" />
      <path d="M12 9.6v4.2" data-id="element-426" data-mp="1p2w90xijkqql" />
      <path d="M12 17.2h.01" data-id="element-427" data-mp="1p5s66jmkfbdz" />
    </Svg>;
}
export function CrackIcon(props: IconProps) {
  return <Svg {...props} data-id="element-428" data-mp="1l46l4azvnqsp">
      <path d="M13.4 2.6 9.6 9.4l4.2 1.6-5.2 10.4 1-7.2-3.8-1.3 4.4-4.4-2.2-1.1 5.4-4.8Z" data-id="element-429" data-mp="1g2ze4e5k6vn3" />
    </Svg>;
}
export function GhostContractorIcon(props: IconProps) {
  return <Svg {...props} data-id="element-430" data-mp="2csgr7e6vfjyt">
      <path d="M5.4 20.4V9.6a6.6 6.6 0 0 1 13.2 0v10.8l-2.2-1.8-2.2 1.8-2.2-1.8-2.2 1.8-2.2-1.8-2.2 1.8Z" data-id="element-431" data-mp="2cv2w162dnldc" />
      <path d="M9.6 10.8h.01" data-id="element-432" data-mp="240ycl7pkpc7u" />
      <path d="M14.4 10.8h.01" data-id="element-433" data-mp="24050rsbrbwiu" />
    </Svg>;
}
export function CorporateIcon(props: IconProps) {
  return <Svg {...props} data-id="element-434" data-mp="1z2n16sjmqtni">
      <rect x="3.4" y="3.6" width="10.2" height="17" rx="1" data-id="element-435" data-mp="1z1byyx5u1tyi" />
      <path d="M13.6 9.4h6.2a.8.8 0 0 1 .8.8v10.4h-7" data-id="element-436" data-mp="2whr6ir2pg2we" />
      <path d="M6.6 7.2h3.6M6.6 11h3.6M6.6 14.8h3.6" data-id="element-437" data-mp="2wjc12gp0rlu9" />
    </Svg>;
}
export function HandshakeIcon(props: IconProps) {
  return <Svg {...props} data-id="element-438" data-mp="2z1nix6qmle55">
      <path d="m2.8 11.4 3.4-3.4h4l2 1.8-2.4 2.2" data-id="element-439" data-mp="2z26yigsszqg0" />
      <path d="M21.2 11.4 17.8 8h-3.2" data-id="element-440" data-mp="2z3i6ytx71mdg" />
      <path d="m9.8 12 2.6 2.4M12 10.6l3 2.8M14.2 10.2l3 2.8" data-id="element-441" data-mp="3408ir51ytvt2" />
      <path d="M6.2 8v7.4l3 2.8h7.2l1.2-1.2" data-id="element-442" data-mp="342us9a8f2ldx" />
    </Svg>;
}
export function FamilyIcon(props: IconProps) {
  return <Svg {...props} data-id="element-443" data-mp="3927kyblyymof">
      <circle cx="8.2" cy="7.4" r="2.8" data-id="element-444" data-mp="3d1y9e8o0wqps" />
      <circle cx="16.4" cy="8.6" r="2.2" data-id="element-445" data-mp="3d2zwjbibd3nv" />
      <path d="M3.4 19.6c0-2.9 2.1-5 4.8-5s4.8 2.1 4.8 5" data-id="element-446" data-mp="3i0jeale7zykk" />
      <path d="M14.2 15.2c.6-.4 1.4-.6 2.2-.6 2.2 0 4 1.8 4 4.4" data-id="element-447" data-mp="3i001tk7ca2dx" />
    </Svg>;
}
export function GoogleIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 48 48" className={className} aria-hidden="true" focusable="false" data-id="element-448" data-mp="3rpt60055jf85">
      <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17Z" data-id="element-449" data-mp="jrx9y8nsxpo" />
      <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.3-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46Z" data-id="element-450" data-mp="4jsetrr21p0y" />
      <path fill="#FBBC05" d="M11.7 28.18A13.8 13.8 0 0 1 11 24c0-1.45.26-2.86.7-4.18v-5.7H4.34A21.9 21.9 0 0 0 2 24c0 3.55.85 6.91 2.34 9.88l7.36-5.7Z" data-id="element-451" data-mp="25li5b3hokixu" />
      <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.36 5.7c1.72-5.2 6.57-9.07 12.3-9.07Z" data-id="element-452" data-mp="2ff8ts8dt4tdj" />
    </svg>;
}
export function FacebookIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 24 24" className={className} aria-hidden="true" focusable="false" data-id="element-453" data-mp="2kbz8osdvlixd">
      <path fill="#1877F2" d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.77-3.91 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.44 2.91h-2.34V22c4.78-.76 8.44-4.92 8.44-9.94Z" data-id="element-454" data-mp="2ybgvx3biwo4m" />
    </svg>;
}
export function TikTokIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" focusable="false" data-id="element-455" data-mp="3anst0o24l21y">
      <path d="M16.6 2h-3.3v13.2a2.9 2.9 0 1 1-2.9-2.9c.3 0 .6 0 .9.1V9a6.3 6.3 0 1 0 5.3 6.2V8.6a7.9 7.9 0 0 0 4.6 1.5V6.8a4.6 4.6 0 0 1-4.6-4.6V2Z" data-id="element-456" data-mp="3fkj8b963vtmb" />
    </svg>;
}
export function StarIcon(props: IconProps) {
  return <Svg {...props} data-id="element-457" data-mp="35u83zliifiew">
      <path d="m12 3.6 2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.8l5.9-.8L12 3.6Z" data-id="element-458" data-mp="35toki0d7olyr" />
    </Svg>;
}
export function ArrowRightIcon(props: IconProps) {
  return <Svg {...props} strokeWidth={2} data-id="element-459" data-mp="2wwxsbz1s5r9g">
      <path d="M4.5 12h14" data-id="element-460" data-mp="2ivlcdnmmdpnk" />
      <path d="m13 6.5 5.5 5.5L13 17.5" data-id="element-461" data-mp="2iwd951rydtff" />
    </Svg>;
}
export function ChevronLeftIcon(props: IconProps) {
  return <Svg {...props} strokeWidth={2} data-id="element-462" data-mp="2my8c0apj8evb">
      <path d="M14.5 5.5 8 12l6.5 6.5" data-id="element-463" data-mp="2mz9moe2myzci" />
    </Svg>;
}
export function ChevronRightIcon(props: IconProps) {
  return <Svg {...props} strokeWidth={2} data-id="element-464" data-mp="l5twfiagnmi2">
      <path d="M9.5 5.5 16 12l-6.5 6.5" data-id="element-465" data-mp="l4sequyxw1rd" />
    </Svg>;
}
export function QuoteIcon(props: IconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={props.className} aria-hidden="true" data-id="element-466" data-mp="351bf6apncspj">
      <path d="M9.4 5.6c-3.3 1.5-5.3 4.3-5.3 7.9 0 3 1.8 4.9 4.2 4.9 2 0 3.6-1.5 3.6-3.5 0-1.9-1.4-3.3-3.2-3.3-.3 0-.7 0-1 .2.4-1.6 1.6-3 3.3-3.9l-1.6-2.3Zm9.2 0c-3.3 1.5-5.3 4.3-5.3 7.9 0 3 1.8 4.9 4.2 4.9 2 0 3.6-1.5 3.6-3.5 0-1.9-1.4-3.3-3.2-3.3-.3 0-.7 0-1 .2.4-1.6 1.6-3 3.3-3.9l-1.6-2.3Z" data-id="element-467" data-mp="3039whqw4uvel" />
    </svg>;
}
export function PlusIcon(props: IconProps) {
  return <Svg {...props} strokeWidth={2} data-id="element-468" data-mp="2hbqt3iy75fc1">
      <path d="M12 5.5v13M5.5 12h13" data-id="element-469" data-mp="2hap7ikjk1ag2" />
    </Svg>;
}
export function HomeIcon(props: IconProps) {
  return <Svg {...props} data-id="element-470" data-mp="2cdfi34w60ys8">
      <path d="M3.4 10.4 12 3.6l8.6 6.8" data-id="element-471" data-mp="2cf0cmuihchq3" />
      <path d="M5.6 12v7.6c0 .5.4.8.9.8h11c.5 0 .9-.3.9-.8V12" data-id="element-472" data-mp="27f5o2xm6g487" />
      <path d="M9.8 20.4v-5.2h4.4v5.2" data-id="element-473" data-mp="altzwmu5xjkg" />
    </Svg>;
}
export function BoltIcon(props: IconProps) {
  return <Svg {...props} data-id="element-474" data-mp="5m7psm9msjfv">
      <path d="M13.4 2.8 4.6 13.4h6.2l-1.2 7.8 8.8-10.6h-6.2l1.2-7.8Z" data-id="element-475" data-mp="5nslwgblgafu" />
    </Svg>;
}
export function PlayIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-476" data-mp="i53ceoxytydq">
      <path d="M8.4 5.4a.8.8 0 0 1 1.22-.68l8.6 5.9a.8.8 0 0 1 0 1.36l-8.6 5.9a.8.8 0 0 1-1.22-.68V5.4Z" data-id="element-477" data-mp="mw1u9sylr4j3" />
    </svg>;
}
export function ClockIcon(props: IconProps) {
  return <Svg {...props} data-id="element-478" data-mp="rud7mdo3vx62">
      <circle cx="12" cy="12" r="9.2" data-id="element-479" data-mp="3ra9ra3lw93gz" />
      <path d="M12 6.8V12l3.2 1.9" data-id="element-480" data-mp="3rbbfzavu1oh6" />
    </Svg>;
}